import classNames from "classnames";
import { useRef } from "react";
import { Container, Heading3, Icon, SwiperLayout } from "shared/components";
import { useViewMode } from "shared/contexts/ViewMode";
import { SwiperSlide } from "swiper/react";

import styles from "./Content062.module.scss";
import { Item } from "./Item";

export const Content062 = ({ payload }) => {
  const title = payload?.title ?? "";
  const attachments = payload?.attachments ?? [];

  const prevRef = useRef(null);
  const nextRef = useRef(null);

  const { isDesktop } = useViewMode();

  return (
    <div className={styles.wrapper}>
      <Container>
        <div className={styles.block}>
          <Heading3 className={styles.title}>{title}</Heading3>
          {isDesktop && (
            <div className={styles["navigation-wrapper"]}>
              <div className={styles["slider-navigation"]}>
                <div
                  ref={prevRef}
                  className={classNames(
                    styles.navigation,
                    styles["navigation-prev"]
                  )}
                >
                  <Icon className={styles.icon} name="arrow_slider_prev" />
                </div>
                <div
                  ref={nextRef}
                  className={classNames(
                    styles.navigation,
                    styles["navigation-next"]
                  )}
                >
                  <Icon className={styles.icon} name="arrow_slider_next" />
                </div>
              </div>
            </div>
          )}
        </div>
      </Container>
      <div className={styles.slider}>
        <SwiperLayout
          prevRef={prevRef}
          nextRef={nextRef}
          watchOverflow={false}
          slidesPerView={"auto"}
          spaceBetween={6}
          slidesPerGroup={1}
          slidesOffsetAfter={30}
        >
          {attachments.map((item) => (
            <SwiperSlide key={item.id} className={styles.slide}>
              <Item className={styles.item} {...item} />
            </SwiperSlide>
          ))}
        </SwiperLayout>
      </div>
    </div>
  );
};

export default Content062;
